import React from 'react';
import { Link } from 'react-router-dom';
import './PublicHeader.css';

const PublicHeader = () => {
  return (
    <header className="public-header shadow-sm">
      <div className="container d-flex justify-content-between align-items-center py-3">
        <div className="logo-section d-flex align-items-center">
          <img src="/images/logo.jpg" alt="Vijaya Diagnostic" className="header-logo" />
        </div>
        <nav className="menu-links">
          <Link to="/about" className="nav-link">About Us</Link>
          <Link to="/privacy" className="nav-link">Privacy Policy</Link>
          <Link to="/terms" className="nav-link">Terms & Conditions</Link>
          <Link to="/contact" className="nav-link">Contact Us</Link>
          <Link to="/#" className="nav-link">Login</Link>
        </nav>
      </div>
    </header>
  );
};

export default PublicHeader;
